import type { DynamicIslandActivity } from '../../context/dynamicIslandTypes'

/** 大类固定顺序：生图 → 漫画 → 工作流 */
const CATEGORY_ORDER: Record<string, number> = {
  'image.generation': 0,
  'timeline.creation': 0,
  'comic.episode-generate': 1,
  'workflow.run': 2,
}

export function sortActivitiesByCategory(activities: DynamicIslandActivity[]): DynamicIslandActivity[] {
  return [...activities].sort((a, b) => {
    const orderA = CATEGORY_ORDER[a.sourceKind] ?? 99
    const orderB = CATEGORY_ORDER[b.sourceKind] ?? 99
    if (orderA !== orderB) return orderA - orderB
    return a.priority - b.priority || a.id.localeCompare(b.id)
  })
}

export function activityIslandAccent(activity: DynamicIslandActivity): DynamicIslandActivity['expanded']['accent'] {
  const { compact, expanded } = activity
  if (
    compact.mode === 'terminal' ||
    compact.mode === 'count' ||
    compact.mode === 'progress' ||
    compact.mode === 'step'
  ) {
    return compact.accent
  }
  return expanded.accent
}

export function activityPreviewProgress(activity: DynamicIslandActivity): number {
  const compact = activity.compact
  if (compact.mode === 'count' || compact.mode === 'progress' || compact.mode === 'step') {
    return compact.progressPercent
  }
  return activity.expanded.progressPercent ?? 0
}

export function activityPreviewHint(activity: DynamicIslandActivity): string {
  if (activity.lifecycle === 'terminal') return ''
  const compact = activity.compact
  if (compact.mode === 'count') return `${compact.done}/${compact.total}`
  if (compact.mode === 'progress' || compact.mode === 'step') return `${compact.progressPercent}%`
  return ''
}
